// Recommendation cards link to the clean product URL so crawlers do not follow Shopify's pr_
// tracking parameters. They go back on just before a shopper follows the link, so Search &
// Discovery still credits the recommendation.
(() => {
  const restore = (event) => {
    const link = event.target.closest?.('a[href]');
    const card = link?.closest('[data-recommendation-query]');
    if (!card || link.search) return;
    if (!link.pathname.endsWith(`/products/${card.getAttribute('handle')}`)) return;

    link.search = card.dataset.recommendationQuery;
  };

  ['pointerdown', 'keydown', 'click'].forEach((type) => document.addEventListener(type, restore, true));
})();
